<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import Vue from "vue";
import { 
  BOSystem,
  BOScanner,
  BOPrinter,
  BOSIU,
  BOVideoPlayer,
  BOCamera
} from "@/utils/BODevice";
export default {
  name:  'App',
  data() {
    return {
      //所有组件列表
      g_modules: [],
      g_class: {
        "BOSystem": BOSystem, 
        "BOPrinter": BOPrinter, 
        "BOSIU": BOSIU,
        "BOScanner": BOScanner,
        "BOVideoPlayer": BOVideoPlayer,
        "BOCamera": BOCamera
      },
      sharedState: this.myStore.state
    }
  },
  created () {
    //单机版
    this.getLocalModules();
  },
  methods: {
    getLocalModules() {
      Vue.prototype.sys = new BOSystem({
        "id": "1",
        "service": "sys",
        "device": 'SYS',
        "devname": '系统服务'
      });
      Vue.prototype.siu = new BOSIU({
        "id": "2",
        "service": "siu",
        "device": 'SIU',
        "devname": '智能电源'
      });
      Vue.prototype.ptr = new BOPrinter({
        "id": "3",
        "service": "ptr",
        "device": 'PTR',
        "devname": '打印机'
      });
      Vue.prototype.ist = new BOScanner({
        "id": "4",
        "service": "ist",
        "device": 'IST',
        "devname": '收票模块'
      });
      Vue.prototype.vp = new BOVideoPlayer({
        "id": "5",
        "service": "vpr",
        "device": 'VPR',
        "devname": '视频播放器'
      })
      Vue.prototype.cam = new BOCamera({
        "id": "6",
        "service": "afr",
        "device": 'AFR',
        "devname": '双目摄像头'
      })
      //单机版使用默认url
      this.myStore.setUrlAction("/boaccount/client/main", "/boaccount/manager/main");
      let _this = this;
      let urls = window.location.href.split('/')
      let isVideo = urls[urls.length-1] === 'video'
      if(!isVideo){
        setTimeout(() => {
          _this.$router.push({ path: '/boaccount' })
        }, 500);
      }
    }
  }
}
</script>
<style lang="less">
  html,body,#app {
    height: 100%;
  }
  #app {
    top: 0;
    padding: 0;
    margin: 0;
    line-height: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-family: "Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
  /*elementui loading css 覆盖 开始*/
  .el-loading-spinner .el-loading-text {
    font-size: 28px !important;
    margin-top: 30px;
    color: #F7636E !important;
  }
  .el-loading-spinner .el-icon-loading {
    color: #F7636E !important;
  }
  .el-loading-spinner{
    font-size: 98px;
    top:40%;
  }
  
  /*elementui loading css 覆盖 结束*/
  .text-btn {
    display:inline-block;
    text-align: left;
    margin-top: 50px;
    padding: 20px 30px;
    background: radial-gradient( 0% 141% at -1% 0%, #C62D2F 0%, #B23B34 100%);
    border-radius: 8px;
    font-weight: 400;
    font-size: 26px;   
    color: #FFFFFF;
  }
  .btn-group {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    .cancle-btn {
      display:inline-block;
      padding: 20px 30px;
      margin: 0 30px;
      background: #FFEEF1;
      border-radius: 8px;
      border: 1px solid #F7636E;
      font-size: 26px;
      color: #F7636E;
    }
    .cancle-btn-mini {
      display:inline-block;
      padding: 10px 15px;
      margin: 0 30px;
      background: #FFEEF1;
      border-radius: 8px;
      border: 1px solid #F7636E;
      font-size: 22px;
      color: #F7636E;
    }
    .confirm-btn {
      display:inline-block;
      padding: 20px 30px;
      background: radial-gradient( 0% 141% at -1% 0%, #C62D2F 0%, #B23B34 100%);
      border-radius: 8px;
      font-size: 26px;   
      color: #FFFFFF;
    }
  }
  .message-box__button {
    background-color: #B63933 !important;
    border-color:#B63933 !important;
  }
</style>
